@if (product$ | async; as product) {
  <div class="product-hero">
    <div class="product-hero-container">
      <div class="product-details-section" >
        <h1 class="product-title">{{ product?.marketingName }}</h1>
        <p class="product-subtitle">{{product?.description}}</p>
        <div class="product-price">
          @if (product?.knbrPrice?.netPrice) {
            <span >${{formatPrice(product?.knbrPrice?.netPrice)}}</span>
          }
          @if (product?.marketingUom) {
            <span class="price-unit">/ {{product?.marketingUom}}</span>
          }
        </div>
      </div>
    </div>
  </div>
} @else {
  <knbr-cwt-spinner></knbr-cwt-spinner>
}

